import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectUser } from '../../../selectors';
import { IBrokerAnalyticsUser, TNewbuildingBrokerFlow } from '../../../types/newbuildingBroker';

export const useNewbuildingBrokerAnalyticsUser = (flowType: TNewbuildingBrokerFlow | undefined) => {
  const user = useSelector(selectUser);

  return useMemo<IBrokerAnalyticsUser>(
    () => ({
      userId: user.isAuthenticated ? user.userId : undefined,
      extra: {
        is_individual: flowType === 'withPartnerRewards',
      },
    }),
    [user, flowType],
  );
};
